import { Capabilities } from "src/hooks/useCapabilities/types";
import { useGranularCapabilities } from "src/hooks/useCapabilities/useGranularCapabilities";
import { useLegacyCapabilities } from "src/hooks/useCapabilities/useLegacyCapabilities";
import { useIsFeatureFlagEnabled } from "src/hooks/useIsFeatureFlagEnabled";
import { FEATURE_FLAGS } from "src/router/featureFlags";

export const useCapabilities = (): Capabilities => {
  const legacyCapabilities = useLegacyCapabilities();
  const granularCapabilities = useGranularCapabilities();
  const isGranularPermissionsEnabled = useIsFeatureFlagEnabled(
    FEATURE_FLAGS.granularPermissions,
  );

  return isGranularPermissionsEnabled
    ? granularCapabilities
    : legacyCapabilities;
};
